import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getdata } from "../../util/global";
import { subscription } from './Datatype';

const frequencies = [
  { value: 'weekly', label: 'Weekly', text: 'every week' },
  { value: 'biweekly', label: 'Bi-weekly', text: 'every 2 weeks' }
];

const durations = [
  { value: '1month', label: '1 Month', text: '1 month' },
  { value: '3months', label: '3 Months', text: '3 months' },
  { value: '1year', label: '1 Year', text: '1 year' }
];

const muted: React.CSSProperties = { fontSize: '0.8rem', color: 'var(--muted)' };
const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

const Checkout = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sub, setsub] = useState<subscription | null>(null);
  const [loaded, setloaded] = useState(false);
  // busy disables the pay button while the payment is in progress; message is shown under it
  const [busy, setbusy] = useState(false);
  const [message, setmessage] = useState('');

  const fetchsubscription = async () => {
    const record = await getdata({ filter: { datatype: "subscriptiondata", _id: id } });
    setsub(record[0] || null);
    setloaded(true);
  };

  useEffect(() => {
    fetchsubscription();
  }, []);

  if (!loaded) return null;

  if (!sub) {
    return (
      <div className="content-area" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', textAlign: 'center' }}>
        <p style={{ margin: '40px 0 16px' }}>Subscription not found</p>
        <Link to="/subscriptions">My Subscriptions</Link>
      </div>
    );
  }

  const itemstotal = Number(sub.itemstotal);
  const deposittotal = Number(sub.deposittotal);
  const frequencytext = frequencies.find((f) => f.value === sub.frequency)!.text;
  const durationtext = durations.find((d) => d.value === sub.duration)!.text;

  const startautopay = async () => {
    setbusy(true);
    setmessage('');
    const res = await getdata({ id }, '/createmandate');
    if (!res || res.error) {
      setbusy(false);
      setmessage(res?.error || 'Could not start payment. Please try again.');
      return;
    }

    // razorpay is loaded globally from index.html; it posts the result to /verifymandate and redirects from there
    if (res.mode === 'razorpay') {
      const rzp = new (window as any).Razorpay({
        key: res.key_id,
        order_id: res.order_id,
        customer_id: res.customer_id,
        amount: res.amount,
        currency: 'INR',
        name: 'Reveen',
        description: sub.label + ' subscription',
        prefill: { name: res.name, contact: res.phone },
        theme: { color: '#00339B' },
        callback_url: window.location.origin + '/verifymandate',
        redirect: true,
        modal: {
          // customer closed the popup without paying
          ondismiss: () => { setbusy(false); setmessage('Payment cancelled.'); }
        }
      });
      rzp.open();
      return;
    }

    const total = Number(res.monthly || 0) + Number(res.deposit || 0);
    const targeturl =
      '/dummygateway?order_id=' +
      encodeURIComponent(res.order_id) +
      '&subscriptionid=' +
      encodeURIComponent(res.subscriptionid) +
      '&amount=' +
      encodeURIComponent(total);
    console.log("targeturl ", targeturl);
    window.location.href = targeturl;
  };

  return (
    <div className="content-area" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>

        <div>
          <div className="eyebrow">STEP 04</div>
          <h2 style={{ fontFamily: 'var(--display)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 24px' }}>Almost there.</h2>

          <div className="section">
            <div className="eyebrow">DELIVERY ADDRESS</div>
            <div style={{ ...row, marginBottom: '6px' }}>
              <strong>{sub.label}</strong>
              <Link to={'/subscribe?id=' + id} style={muted}>Change</Link>
            </div>
            <div>{sub.address}, {sub.pin}</div>
            <div style={muted}>{sub.name} · {sub.phone}</div>
          </div>

          <div className="section">
            <div className="eyebrow">PLAN</div>
            {sub.items.map((item) => (
              <div key={item.productid}>{item.quantity} x {item.name}</div>
            ))}
            <div style={{ ...muted, marginTop: '6px' }}>
              {frequencytext} · preferably {sub.preferredday} · {durationtext} plan
            </div>
          </div>

          <div className="section">
            <div className="eyebrow">HOW PAYMENT WORKS</div>
            <p style={{ ...muted, margin: 0 }}>
              You will set up UPI Autopay once. Your first payment covers the first month plus a refundable deposit. After that the monthly amount is charged automatically. Pause or cancel anytime from My Subscriptions.
            </p>
          </div>
        </div>

        <div className="c-form" style={{ alignSelf: 'start' }}>
          <div className="eyebrow">ORDER SUMMARY</div>

          <div style={{ ...row, marginBottom: '14px' }}>
            <span>Monthly</span>
            <span>₹{itemstotal}</span>
          </div>

          <div style={{ marginBottom: '14px' }}>
            <div style={row}>
              <span>One-time refundable deposit</span>
              <span>₹{deposittotal}</span>
            </div>
            <div style={muted}>Returned when your jars come home.</div>
          </div>

          <hr style={{ border: 'none', borderTop: '1px solid var(--rule)', margin: '16px 0' }} />

          <div style={{ ...row, fontWeight: 600, marginBottom: '6px' }}>
            <span>First payment</span>
            <span>₹{itemstotal + deposittotal}</span>
          </div>
          <div style={{ ...muted, marginBottom: '20px' }}>Then ₹{itemstotal} every month · {durationtext} plan</div>

          {sub.status === 'pending' ? (
            <>
              <button type="button" className="btn-blue full-width" onClick={startautopay} disabled={busy}>{busy ? 'Opening payment...' : 'Set up UPI Autopay'}</button>
              {message && <div style={{ ...muted, textAlign: 'center', marginTop: '8px', color: '#B42318' }}>{message}</div>}
            </>
          ) : (
            <>
              <div style={{ ...muted, textAlign: 'center' }}>This subscription is already {sub.status}.</div>
              <div style={{ textAlign: 'center', marginTop: '8px' }}><Link to="/subscriptions">My Subscriptions</Link></div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default Checkout;
